import CustomerPagingResultModelBase from '../_generated/modelBases/customer-paging-result-model-base';

export default class CustomerPagingResultModel extends CustomerPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
